export default __webpack_public_path__ + "static/media/Government_Of_Sharjah.8b4ea13f.svg";